import { render } from "./EditOrganization.vue?vue&type=template&id=faa74c0a&scoped=true"
import script from "./EditOrganization.vue?vue&type=script&lang=js"
export * from "./EditOrganization.vue?vue&type=script&lang=js"

import "./EditOrganization.vue?vue&type=style&index=0&id=faa74c0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faa74c0a"]])

export default __exports__